import { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button, makeStyles } from '@material-ui/core';
import MenuBookIcon from '@material-ui/icons/MenuBook';

const QETA_DOCS_URL =
  '/docs/default/component/backstage/features/qa-and-tagging/';

// Only the Q&A landing page shows the guide, so it does not crowd the header
// controls on question and article pages.
const QETA_LANDING_PATHS = ['/qeta', '/qeta/'];

export const isQetaLandingPath = (pathname: string) =>
  QETA_LANDING_PATHS.includes(pathname);

const useStyles = makeStyles(theme => {
  const fontColor = theme.getPageTheme({ themeId: 'home' }).fontColor;
  return {
    guideButton: {
      '&&': {
        color: fontColor,
        borderColor: fontColor,
      },
      '&&:hover': {
        borderColor: fontColor,
        backgroundColor: 'rgba(0, 31, 61, 0.08)',
      },
      '&& .MuiSvgIcon-root': {
        color: fontColor,
        fill: fontColor,
      },
    },
  };
});

/**
 * "Guide" button rendered in the Q&A page header, using explicit page-theme
 * font colour so it stays navy in both light and dark mode.
 */
export const QetaGuideButton = () => {
  const classes = useStyles();
  const location = useLocation();

  const isLandingPage = useMemo(
    () => isQetaLandingPath(location.pathname),
    [location.pathname],
  );

  if (!isLandingPage) {
    return null;
  }

  return (
    <Button
      component={Link}
      variant="outlined"
      className={classes.guideButton}
      startIcon={<MenuBookIcon />}
      to={QETA_DOCS_URL}
    >
      Guide
    </Button>
  );
};
